<ag-grid-angular
    *ngIf="exports && exports.length"
    [rowData]="exports"
    [gridOptions]="gridOptions"
    [defaultColDef]="defaultColDef"
    #agGridExports
    class="ag-theme-material"
>
</ag-grid-angular>

<on-empty-list
    [message]="'company.accountant-export.no-export' | translate"
    *ngIf="exports && !exports.length"
>
</on-empty-list>
